import axios from 'axios'
import { toast } from 'react-toastify'
import apiUrl from 'src/config.json'
import { logout, loadFromLocalStorage, saveToLocalStorage } from './loginService'

let accessToken

export function refreshaccessToken() {
  if (!accessToken) {
    accessToken = localStorage.getItem('access_token')
  }
}

export function getQueryStringParamsObject(params) {
  let result = {}
  let splitted = params.split('&')

  splitted.map((s, inx) => {
    let keyVal = s.split('=')
    if (keyVal.length > 1 && keyVal[1] !== '' && keyVal[1] !== undefined) {
      result[keyVal[0].charAt(0).toUpperCase() + keyVal[0].slice(1)] = keyVal[1]
    }
  })

  return result
}

export function shouldUpdate() {
  return sessionStorage.getItem('update') === 'critical'
}

// refreshHeaderToken()
axios.interceptors.request.use(
  (config) => {
    /** In dev, intercepts request and logs it into console for dev */
    let token = localStorage.getItem('access_token')
    config.headers['Authorization'] = `Bearer ${token}`
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response && error.response.status >= 400 && error.response.status < 500

  if (!expectedError) {
    toast.error('An unexpected error occurrred.')
  } else {
    switch (error.response.status) {
      case 400:
        toast.error(
          error.response?.data?.Message ? error.response?.data?.Message : 'خطا در ارسال اطلاعات',
        )

        // toast.error('درخواست نامعتبر است.')
        break
      case 401:
        let rUrl = localStorage.getItem('returnUrl')

        if (!rUrl && window.location.href) {
          rUrl = window.location.href?.substring(window.location.href.indexOf('#/') + 1)
        }
        toast.error(
          error.response?.data?.Message ? error.response?.data?.Message : 'خطای احراز هویت. 401',
        )

        logout(rUrl)
        break
      case 403:
        toast.error(
          error.response?.data?.Message ? error.response?.data?.Message : 'دسترسی نامعتبر',
        )
        break
      case 404:
        toast.error('محتوایی یافت نشد')
        break
      case 409:
        toast.error('خطای ارسال داده نامعتبر - 409')
        break
      default:
        toast.error(error.response.status)
        break
    }
  }
  return Promise.reject(error)
})

const deafultAxios = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
}

export default deafultAxios
